<div *ngFor="let m of members" class="lock-item">
  <lockvue-user-details-item [value]="m" [forceNewLine]="true"></lockvue-user-details-item>
</div>
